import * as React from 'react';
import { ColumnProps } from '@rtkwlf/ui';
import { useSelector } from 'react-redux';
import { CredentialSecret } from '../../../../types';
import { memoizedCredentialSchemaSelector } from '../../../../selectors/credentialSchemaSelectors';
import { ColumnSchemaIcon } from './ColumnSchemaIcon';
import { ColumnDetails } from './ColumnDetails';
import { ColumnStatus } from './ColumnStatus';
import { ColumnAction } from './ColumnAction';

type onDelete = (credential: CredentialSecret) => void;

export const useColumns = (onDelete: onDelete) => {
  const schemas = useSelector(memoizedCredentialSchemaSelector.getSchemaMap);

  return React.useMemo<ColumnProps<CredentialSecret>[]>(
    () => [
      {
        key: 'schemaIcon',
        title: 'Cloud Application',
        width: 20,
        justify: 'center',
        render: ({ record: { type } }) => (
          <ColumnSchemaIcon schema={schemas[type]} />
        ),
      },
      {
        key: 'details',
        title: 'Account Information',
        width: 40,
        justify: 'flex-start',
        render: ({ record: secret }) => (
          <ColumnDetails schema={schemas[secret.type]} secret={secret} />
        ),
      },
      {
        key: 'status',
        title: 'Status',
        width: 25,
        justify: 'flex-start',
        render: ({ record: { status } }) => <ColumnStatus status={status} />,
      },
      {
        key: 'actions',
        title: 'Actions',
        width: 13,
        justify: 'flex-start',
        render: ({ record: secret }) => (
          <ColumnAction
            schema={schemas[secret.type]}
            secret={secret}
            onDelete={onDelete}
          />
        ),
      },
    ],
    [onDelete, schemas],
  );
};
